import { Fab, Grid, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import { MoreVert } from '@material-ui/icons';
import { Circle } from '@mui/icons-material';
import _ from 'lodash';
import AddCollectionPopup from './AddCollectionPopup';
import { AddPreAssesmentPopup } from './AddPreAssesmentPopup';
import { AddExamPopup } from './AddExamPopup';
import AddAgendaPopup from './AddAgendaPopup';
import EditIcon2 from '../../assets/EditIcon2';
import DocumentIcon from '../../assets/DocumentIcon';
import { getCollectionList, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import useCollection from './hooks/useCollection';
import JourneyCard, { MenuItems } from '../common/JourneyCard';
import ReactDnD from '../common/ReactDnD';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';
import AgendaIcon from '../../assets/AgendaIcon';
import Lock from '../../assets/Lock';
import EditIcon from '../../assets/SvgIonReorderTwo';
import { CustomMenu } from '../shared/CustomMenu';
import DeleteMenuIcon from '../../assets/DeleteMenuIcon';
const useStyles = makeStyles(() => ({
  titleContainer: {
    height: '60px',
    color: '#10182B',
    border: '1px solid #F4F4F4',
    padding: '20px',
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    height: '14%',
    justifyContent: 'center',
  },
  contentContainer: {
    background: '#F9FAFB',
    textAlign: 'center',
    height: '86%',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  emptyContainer: {
    width: '237px',
    height: '145px',
  },
  emptySubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '140%',
    textAlign: 'center',
    color: '#667085',
    marginBottom: '18px',
  },
  emptyText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    color: '#10182B',
    marginBottom: '18px',
  },
  cta: {
    color: '#622FEE',
    borderBottom: '1.5px solid #622FEE',
    cursor: 'pointer',
    fontWeight: '600',
  },
  card: {
    background: '#f3f4f7',
    padding: '10px',
    width: '95%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    marginBottom: '10px',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
  },
  content: {
    width: '100%',
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  img: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  qinfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    fontSize: '14px',
    color: '#667085',
    fontWeight: '500',
  },
  jouneyHeading: {
    width: '100%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 10px',
  },
  equlaIcon: {
    fontSize: '18px',
  },
  lockIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

const RightSideCollection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openAddPopup, setOpenAddPopup] = useState(false);
  const [isOpenAssesment, setIsOpenAssesment] = useState(false);
  const [isOpenExam, setIsOpenExam] = useState(false);
  const [isOpenAgenda, setIsOpenAgenda] = useState(false);
  const [anchorElAssessment, setAnchorElAssessment] = useState(null);
  const [anchorElExam, setAnchorElExam] = useState(null);
  const [anchorElAgenda, setAnchorElAgenda] = useState(null);
  const [anchorElLock, setAnchorElLock] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalQuestions, setTotalQeustions] = useState([]);
  const [totalDuration, setTotalDuration] = useState('');
  const [availableJourneys, setAvailableJourney] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [isConfirmDelete, setIsConfirmDelete] = useState(null);
  const [isConfirmDeleteAgenda, setIsConfirmDeleteAgenda] = useState(false);
  const [isConfirmDeleteLock, setIsConfirmDeleteLock] = useState(false);
  const [preAssesmentQ, setPreAssessmentQ] = useState([]);
  const [preAssesmentQReq, setPreAssessmentQReq] = useState(0);
  const [examQReq, setExamQReq] = useState(0);

  const details = useSelector((state) => state.getCollection.collection);
  const { fetchCollection: fetchCollectionFromHook } = useCollection();

  useEffect(() => {
    setAvailableJourney(details?.journeys || []);
  }, [details]);

  // Create combined array with lock card at the correct position
  const getCombinedData = () => {
    const journeys = availableJourneys || [];
    const lockIndex = details?.lockIndex !== undefined ? details.lockIndex : -1;

    if (lockIndex === -1) {
      return journeys;
    }

    if (journeys.length === 0) {
      return journeys;
    }

    const combined = [...journeys];
    const lockCard = { id: 'lock-card', type: 'lock', isLock: true };
    // Ensure lock is never placed at or after the last journey
    const insertPosition = Math.min(lockIndex, Math.max(0, journeys.length - 1));
    combined.splice(insertPosition, 0, lockCard);

    return combined;
  };

  const closePopup = () => {
    setOpenAddPopup(false);
  };

  const getDetailsExam = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', details.id).replace('TYPE', 'post_assessment'),
      );
      setTotalQeustions(res.questions || []);
      setTotalDuration(res.duration);
      setExamQReq(res.numberQuestions);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const getDetailsAssessment = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', details.id).replace('TYPE', 'pre_assessment'),
      );
      setPreAssessmentQ(res.questions || []);
      setPreAssessmentQReq(res.numberQuestions);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (details && details.id && details.postAssessmentId) {
      getDetailsExam();
    }
    if (details && details.id && details.preAssessmentId) {
      getDetailsAssessment();
    }
  }, [details]);

  const fetchCollection = () => {
    if (details?.id) {
      fetchCollectionFromHook(details.id);
    }
  };

  const fetchCollectionList = async (selectedCollectionId = null) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.JOURNEY_COLLECTION_LIST)
      .then((response) => {
        const collectionId = selectedCollectionId || response[0]?.id;
        dispatch(getCollectionList('fetch', response, collectionId));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const handleDeleteJourney = () => {
    setIsConfirmDelete(true);
    setAnchorEl(null);
  };

  const handleDelete = () => {
    const journeyTaggedQAssess = preAssesmentQ?.filter((d) => d.journeyId === selectedId) || [];
    const journeyTaggedQExam = totalQuestions?.filter((d) => d.journeyId === selectedId) || [];

    if (
      preAssesmentQ.length - journeyTaggedQAssess.length < preAssesmentQReq &&
      totalQuestions.length - journeyTaggedQExam.length < examQReq
    ) {
      ErrorToast(
        'Cannot remove the journey as there are insufficient number of questions in the Pre-Assessment and Exam Question bank.',
      );
      setIsConfirmDelete(false);
    } else if (preAssesmentQ.length - journeyTaggedQAssess.length < preAssesmentQReq) {
      ErrorToast(
        'Cannot remove the journey as there are insufficient number of questions in the Pre-Assessment Question bank.',
      );
      setIsConfirmDelete(false);
    } else if (totalQuestions.length - journeyTaggedQExam.length < examQReq) {
      ErrorToast('Cannot remove the journey as there are insufficient number of questions in the Exam Question bank.');
      setIsConfirmDelete(false);
    } else {
      const temp = availableJourneys.filter((data) => data.id !== selectedId).map((data) => data.id);
      handleUpdateJourney(temp);
    }
  };

  const handleUpdateJourney = async (arr, skipListApi = false) => {
    dispatch(showProgress(true));
    try {
      await service.post(apiEndpoints.COLLECTION_UPDATE_JOURNEY.replace('JOURNEY_ID', details.id), { journeyIds: arr });
      notifySuccess('Jouney updated successfully');
      fetchCollection();
      if (!skipListApi) {
        fetchCollectionList(_.get(details, 'id'));
      }
      setIsConfirmDelete(false);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleDeleteAgenda = async () => {
    dispatch(showProgress(true));
    try {
      await service.delete(
        apiEndpoints.COLLECTION_RESOURCE_DETAIL.replace('COLLECTION_ID', details.id).replace(
          'RESOURCE_ID',
          details.agendaId,
        ),
      );
      notifySuccess('Agenda deleted successfully');
      fetchCollection();
      setIsConfirmDeleteAgenda(false);
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const agendaMenuItems = [
    {
      name: 'Edit Agenda',
      icon: <EditIcon2 />,
    },
    {
      name: 'Delete Agenda',
      icon: <DeleteMenuIcon fontSize="small" />,
    },
  ];

  const handleAgendaMenuItemClick = (e, menuItemName) => {
    if (menuItemName === 'Edit Agenda') {
      setIsOpenAgenda(true);
    } else if (menuItemName === 'Delete Agenda') {
      setIsConfirmDeleteAgenda(true);
    }
  };

  const lockMenuItems = [
    {
      name: 'Delete Lock',
      icon: <DeleteMenuIcon fontSize="small" />,
    },
  ];

  const handleLockMenuItemClick = (e, menuItemName) => {
    if (menuItemName === 'Delete Lock') {
      setIsConfirmDeleteLock(true);
    }
  };

  const handleAddLock = async () => {
    dispatch(showProgress(true));
    try {
      const firstJourneyId = details?.journeys?.length > 0 ? details.journeys[0].id : 0;
      const payload = {
        elementId: firstJourneyId.toString(),
        elementType: 'journey',
      };

      await service.post(apiEndpoints.COLLECTION_LOCK.replace('COLLECTION_ID', details.id), payload);

      notifySuccess('Lock added successfully');
      fetchCollection();
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const handleUpdateLockPosition = async (newLockIndex) => {
    // Ensure lock is never placed at or after the last journey
    const validLockIndex = Math.min(newLockIndex, Math.max(0, availableJourneys.length - 1));

    dispatch(showProgress(true));
    try {
      const journeyId = validLockIndex < availableJourneys.length ? availableJourneys[validLockIndex].id : 0;
      const payload = {
        elementId: journeyId.toString(),
        elementType: 'journey',
      };

      await service.post(apiEndpoints.COLLECTION_LOCK.replace('COLLECTION_ID', details.id), payload);

      fetchCollection();
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const handleDeleteLock = async () => {
    dispatch(showProgress(true));
    try {
      await service.delete(apiEndpoints.COLLECTION_LOCK.replace('COLLECTION_ID', details.id));
      notifySuccess('Lock deleted successfully');
      fetchCollection();
      setIsConfirmDeleteLock(false);
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const handleDragEnd = (newData) => {
    // Separate lock from journeys
    const journeysOnly = newData.filter((item) => !item.isLock && item.type !== 'lock');
    const lockItem = newData.find((item) => item.isLock || item.type === 'lock');

    // Find new lock position (count how many journeys are before the lock)
    let newLockIndex = -1;
    if (lockItem) {
      const lockPosition = newData.indexOf(lockItem);
      // Count journeys before the lock
      const journeysBeforeLock = newData
        .slice(0, lockPosition)
        .filter((item) => !item.isLock && item.type !== 'lock').length;

      // Check if lock is being placed after the last journey
      if (journeysBeforeLock >= journeysOnly.length && journeysOnly.length > 0) {
        ErrorToast('Lock cannot be placed after the last journey');
        // Return early - no state updates, no API calls, drag operation is reverted
        return;
      }

      // Prevent lock from being after or at the last journey (must be before the last journey)
      if (journeysBeforeLock < journeysOnly.length && journeysOnly.length > 0) {
        newLockIndex = Math.min(journeysBeforeLock, journeysOnly.length - 1);
      }
    }

    // Update journeys only if lock position is valid
    setAvailableJourney(journeysOnly);

    // Update lock position if it changed and is valid (API call only happens here)
    if (lockItem && newLockIndex !== details?.lockIndex && newLockIndex >= 0 && newLockIndex < journeysOnly.length) {
      handleUpdateLockPosition(newLockIndex);
    }
  };

  const getSubText = () => {
    let text = '';
    if (details?.preAssessmentId && details?.postAssessmentId) {
      text = 'All the Pre-Assessment and Exam questions associated with this journey will be deleted as well.';
    } else if (details?.preAssessmentId) {
      text = 'All the Pre-Assessment questions associated with this journey will be deleted as well.';
    } else if (details?.postAssessmentId) {
      text = 'All the Exam questions associated with this journey will be deleted as well.';
    }
    return text;
  };
  return (
    <Grid style={{ height: '450px' }} key={details?.id}>
      <Grid className={classes.jouneyHeading}>
        <Typography variant="h6">Journeys</Typography>
      </Grid>

      <Grid
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: '20px',
          width: '100%',
          margin: '10px 0px ',
        }}
      >
        {details?.isEpg && !details?.agendaId && (
          <Typography
            className={classes.cta}
            onClick={() => {
              setIsOpenAgenda(true);
            }}
          >
            + Add Agenda
          </Typography>
        )}
        {!details?.preAssessmentId && (
          <Typography
            className={classes.cta}
            onClick={() => {
              if (details?.journeys?.length > 0) {
                setIsOpenAssesment(true);
              } else {
                ErrorToast('Please add atleast 1 journey first to create pre-assessment');
              }
            }}
          >
            + Add Pre-Assessment
          </Typography>
        )}
        {!details?.postAssessmentId && (
          <Typography
            className={classes.cta}
            onClick={() => {
              if (details?.journeys?.length > 0) {
                setIsOpenExam(true);
              } else {
                ErrorToast('Please add atleast 1 journey first to create exam');
              }
            }}
          >
            + Add Exam
          </Typography>
        )}

        {_.get(details, 'isEpg') &&
          (_.isUndefined(_.get(details, 'lockIndex')) || _.get(details, 'lockIndex') === -1) &&
          _.get(details, 'journeys', []).length > 0 && (
            <>
              <Typography style={{ color: '#622FEE' }}>|</Typography>
              <Typography className={classes.cta} onClick={handleAddLock}>
                + Add Lock
              </Typography>
            </>
          )}
      </Grid>

      {details?.journeys?.length === 0 && (
        <Grid item className={classes.contentContainer}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            alignContent="center"
            style={{ height: '100%' }}
          >
            <Grid item className={classes.emptyContainer}>
              <Typography className={classes.emptyText}>You dont have any journey added in the Collection</Typography>
              <Typography className={classes.emptySubText}>Add your first journey</Typography>
              <Fab
                aria-label="Add"
                className={classes.fab}
                color="primary"
                onClick={() => {
                  setOpenAddPopup(true);
                }}
              >
                <AddIcon />
              </Fab>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
      )}
      <Grid style={{ width: '100%' }}>
        {details?.agendaId && (
          <div className={classes.card}>
            <Grid className={classes.wrapper}>
              <Grid className={classes.img}>
                <AgendaIcon />
              </Grid>
              <Grid className={classes.content}>
                <Grid className={classes.title}>
                  <Typography>Agenda</Typography>
                  <div>
                    <MoreVert onClick={(e) => setAnchorElAgenda(e.currentTarget)} style={{ cursor: 'pointer' }} />
                    <CustomMenu
                      id={details.agendaId}
                      anchorEl={anchorElAgenda}
                      handleClose={() => setAnchorElAgenda(null)}
                      handleMenuItemClick={handleAgendaMenuItemClick}
                      menuItems={agendaMenuItems}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
        {details?.preAssessmentId && (
          <div className={classes.card}>
            <Grid className={classes.wrapper}>
              <Grid className={classes.img}>
                <DocumentIcon />
              </Grid>
              <Grid className={classes.content}>
                <Grid className={classes.title}>
                  <Typography>Pre-Assessment</Typography>
                  <div>
                    <MoreVert onClick={(e) => setAnchorElAssessment(e.currentTarget)} style={{ cursor: 'pointer' }} />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}

        {details?.journeys?.length > 0 && (
          <>
            <ReactDnD
              data={getCombinedData()}
              setData={handleDragEnd}
              setModifiedOrderIds={(orderIds) => {
                // Check if lock is being placed after the last journey
                const lockIndex = orderIds.findIndex((id) => id === 'lock' || id === 'lock-card');
                const journeyIds = orderIds.filter((id) => id !== 'lock' && id !== 'lock-card');

                if (lockIndex !== -1 && lockIndex >= journeyIds.length && journeyIds.length > 0) {
                  // Lock is after last journey - don't call API, error already shown in handleDragEnd
                  return;
                }

                // Filter out lock ID and update journeys
                handleUpdateJourney(journeyIds, true);
              }}
              renderItem={(item) => {
                if (item.isLock || item.type === 'lock') {
                  return (
                    <div className={classes.card}>
                      <p className={classes.equlaIcon}>
                        <EditIcon />
                      </p>
                      <Grid className={classes.wrapper}>
                        <Grid className={classes.img}>
                          <Lock />
                        </Grid>
                        <Grid className={classes.content}>
                          <Grid className={classes.title}>
                            <Typography>Content Lock</Typography>
                            <div>
                              <MoreVert
                                onClick={(e) => setAnchorElLock(e.currentTarget)}
                                style={{ cursor: 'pointer' }}
                              />
                              <CustomMenu
                                id="lock-menu"
                                anchorEl={anchorElLock}
                                handleClose={() => setAnchorElLock(null)}
                                handleMenuItemClick={handleLockMenuItemClick}
                                menuItems={lockMenuItems}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  );
                }
                // Check if this journey is after the lock
                const combinedData = getCombinedData();
                const lockPosition = combinedData.findIndex((i) => i.isLock || i.type === 'lock');
                const itemPosition = combinedData.findIndex((i) => i.id === item.id);
                const isAfterLock = lockPosition !== -1 && itemPosition > lockPosition;

                return (
                  <JourneyCard
                    journeyData={item}
                    setAnchorEl={setAnchorEl}
                    setSelectedId={setSelectedId}
                    showLock={isAfterLock}
                  />
                );
              }}
              calledFrom="collection"
              key={details?.id}
              id={details?.id}
            />
            <MenuItems anchorEl={anchorEl} setAnchorEl={setAnchorEl} onDelete={handleDeleteJourney} />
          </>
        )}

        {details?.postAssessmentId && (
          <div className={classes.card} style={{ marginTop: '10px', marginBottom: '10px' }}>
            <Grid className={classes.wrapper}>
              <Grid className={classes.img}>
                <DocumentIcon />
              </Grid>
              <Grid className={classes.content}>
                <Grid className={classes.title}>
                  <Typography>Exam</Typography>
                  <div className={classes.lockIconContainer}>
                    {details?.lockIndex !== undefined && details.lockIndex >= 0 && <Lock />}
                    <MoreVert onClick={(e) => setAnchorElExam(e.currentTarget)} style={{ cursor: 'pointer' }} />
                  </div>
                </Grid>
                <Typography variant="p" className={classes.qinfo}>
                  {totalQuestions?.length || 0} {(totalQuestions?.length || 0) > 1 ? 'Questions' : 'Question'}{' '}
                  <Circle style={{ fontSize: '10px' }} /> {totalDuration} mins
                </Typography>
              </Grid>
            </Grid>
          </div>
        )}
        <Menu
          id="simple-menu"
          anchorEl={anchorElAssessment}
          keepMounted
          open={Boolean(anchorElAssessment)}
          onClose={() => setAnchorElAssessment(null)}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            style={{ display: 'flex', gap: '10px' }}
            onClick={() => {
              setIsOpenAssesment(true);
              setAnchorElAssessment(null);
            }}
          >
            <EditIcon2 /> Edit Pre-Assessment
          </MenuItem>
          {/* <MenuItem style={{ display: 'flex', gap: '10px' }}>
            <Delete /> Delete Pre-Assessment
          </MenuItem> */}
        </Menu>

        <Menu
          id="simple-menu"
          anchorEl={anchorElExam}
          keepMounted
          open={Boolean(anchorElExam)}
          onClose={() => setAnchorElExam(null)}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            style={{ display: 'flex', gap: '10px' }}
            onClick={() => {
              setIsOpenExam(true);
              setAnchorElExam(null);
            }}
          >
            <EditIcon2 /> Edit Exam
          </MenuItem>
          {/* <MenuItem style={{ display: 'flex', gap: '10px' }}>
            <Delete /> Delete Exam
          </MenuItem> */}
        </Menu>
      </Grid>

      {openAddPopup && <AddCollectionPopup id={details?.id} edit close={closePopup} />}
      {isOpenAssesment && (
        <AddPreAssesmentPopup
          isOpen={isOpenAssesment}
          setIsOpen={setIsOpenAssesment}
          isEdit={details?.preAssessmentId}
          fetchCollection={fetchCollection}
        />
      )}
      {isOpenExam && (
        <AddExamPopup
          isOpen={isOpenExam}
          setIsOpen={setIsOpenExam}
          isEdit={details?.postAssessmentId}
          fetchCollection={fetchCollection}
        />
      )}
      {isOpenAgenda && (
        <AddAgendaPopup
          isOpen={isOpenAgenda}
          close={() => setIsOpenAgenda(false)}
          collectionId={details?.id}
          agendaId={details?.agendaId}
          fetchCollection={fetchCollection}
        />
      )}

      <ConfirmationDialog
        title="Are you sure you want to remove this Journey?"
        subText={getSubText()}
        onClose={setIsConfirmDelete}
        isOpen={isConfirmDelete}
        confirmFn={handleDelete}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="500px"
        height="250px"
      />

      <ConfirmationDialog
        title="Are you sure you want to delete this Agenda?"
        subText="This action cannot be undone."
        onClose={setIsConfirmDeleteAgenda}
        isOpen={isConfirmDeleteAgenda}
        confirmFn={handleDeleteAgenda}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="300px"
        height="250px"
      />

      <ConfirmationDialog
        title="Are you sure you want to delete this Lock?"
        subText="This action cannot be undone."
        onClose={setIsConfirmDeleteLock}
        isOpen={isConfirmDeleteLock}
        confirmFn={handleDeleteLock}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="300px"
        height="250px"
      />
    </Grid>
  );
};

export default RightSideCollection;
